import { render } from "./App.vue?vue&type=template&id=7b303d6e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7b303d6e&lang=css"

import exportComponent from "/home/joeyd/Documents/Work/Clients/Rica/Development/rica-tuning-app/rica-tune-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__